import { render } from "./ActivityTrackingReport.vue?vue&type=template&id=c4d66210&scoped=true"
import script from "./ActivityTrackingReport.vue?vue&type=script&lang=js"
export * from "./ActivityTrackingReport.vue?vue&type=script&lang=js"

import "./ActivityTrackingReport.vue?vue&type=style&index=0&id=c4d66210&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d66210"]])

export default __exports__